import React from "react";
import PropTypes from "prop-types";
import CaretLeft from "../../icons/CaretLeft";
import css from "./index.module.css";

function Header({
  children,
  helpText,
  onClickBackArrow,
  rightContent,
  rightContentText,
  subtitle
}) {
  let caretEnabled = onClickBackArrow ? css.header : "";

  return (
    <div className={caretEnabled}>
      {onClickBackArrow && (
        <div className={css.caret} onClick={onClickBackArrow}>
          <CaretLeft />
        </div>
      )}
      <div className={css.headerGroup}>
        <h2 className={css.title}>{children}</h2>
        <span className={css.subtitle}>{subtitle}</span>
        <span
          className={rightContentText ? css.rightContentText : css.rightContent}
        >
          {rightContent}
        </span>
      </div>
      <div className={css.helpText}>{helpText}</div>
    </div>
  );
}

Header.propTypes = {
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  rightContent: PropTypes.any,
  rightContentText: PropTypes.bool,
  helpText: PropTypes.string,
  onClickBackArrow: PropTypes.func
};

Header.defaultProps = {
  subtitle: "",
  rightContent: "",
  rightContentText: false,
  helpText: "",
  onClickBackArrow: null
};

export default Header;
